export default __webpack_public_path__ + "578cc9555802942426bc29529a422b87.png";